import React from 'react';
import './PrivacyPolicyPage.css';

function PrivacyPolicyPageRuLite() {
    return (
        <div className="privacy-policy-container">
      <h1>Политика Конфиденциальности Tasbih Dhikr Lite</h1>
      <p>Последнее обновление: 31 января 2024 года</p>

      <h2>Введение</h2>
      <p>Добро пожаловать в приложение Tasbih Dhikr Lite. Настоящая политика конфиденциальности предназначена для информирования вас о том, как мы обрабатываем ваши данные при использовании нашего приложения. Единственный сбор данных в этом приложении осуществляется через AdMob, сервис рекламы Google, и мы не собираем активно никакие личные данные.</p>

      <h2>1. Сбор и использование ваших личных данных</h2>
      <h3>a. Типы собираемых данных</h3>
      <h4>i. Использование данных через AdMob</h4>
      <p>Наше приложение использует AdMob для показа рекламы. AdMob может собирать данные, такие как ваш IP-адрес, идентификатор устройства и информацию об использовании приложения. Эти данные используются для предоставления и улучшения рекламного опыта.</p>

      <h3>b. Использование данных</h3>
      <p>Данные, собранные AdMob, используются для:</p>
      <ul>
        <li>Предоставления и персонализации рекламы в приложении.</li>
        <li>Анализа эффективности показанных рекламных объявлений.</li>
      </ul>

      <h3>c. Контроль со стороны пользователя</h3>
      <p>Вы можете контролировать использование ваших данных для персонализированной рекламы через настройки вашего устройства.</p>

      <h2>2. Передача данных</h2>
      <p>Ваши данные могут быть переданы и храниться на компьютерах, расположенных за пределами вашего государства, провинции или страны, где законы о защите данных могут отличаться.</p>

      <h2>3. Раскрытие ваших личных данных</h2>
      <p>Данные, собранные AdMob, могут быть переданы в соответствии с политикой конфиденциальности Google и юридическими требованиями.</p>

      <h2>4. Безопасность ваших личных данных</h2>
      <p>Безопасность ваших данных очень важна для нас. Однако ни один метод передачи данных через интернет или электронное хранение не является на 100% безопасным.</p>

      <h2>5. Ссылки на другие сайты</h2>
      <p>Наша служба может содержать ссылки на другие сайты. Если вы нажмете на ссылку третьей стороны, вы будете перенаправлены на сайт этой третьей стороны.</p>

      <h2>6. Изменения в настоящей Политике Конфиденциальности</h2>
      <p>Мы можем время от времени обновлять нашу Политику Конфиденциальности. Мы уведомим вас о любых изменениях, опубликовав новую Политику Конфиденциальности на этой странице.</p>

      <h2>7. Свяжитесь с нами</h2>
      <p>Если у вас есть вопросы о настоящей Политике Конфиденциальности, пожалуйста, свяжитесь с нами.</p>

      <h2>Полезные ссылки</h2>
      <p><a href="https://policies.google.com/privacy">Политика конфиденциальности Google</a></p>
    </div>
    );
}

export default PrivacyPolicyPageRuLite;
